import { render } from "./ActivityCountdown.vue?vue&type=template&id=38850244&scoped=true"
import script from "./ActivityCountdown.vue?vue&type=script&lang=js"
export * from "./ActivityCountdown.vue?vue&type=script&lang=js"

import "./ActivityCountdown.vue?vue&type=style&index=0&id=38850244&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38850244"]])

export default __exports__